export default "__VITE_ASSET__Bb59GgZM__"